export default "__VITE_ASSET__BJQJvtQx__"